import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AlertService} from "../services";
import {Subject} from "rxjs";
import {ProductService} from "../services/product.service";
import {ServiceService} from "../services/service.service";
import {ComponentTitleService} from "../services/componentTitle.service";

import { locale as polish } from './i18n/pl';
import { locale as english } from './i18n/en';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {FormGroup} from "@angular/forms";
import {first, takeUntil} from "rxjs/operators";
import {MatDialog} from "@angular/material/dialog";
import {Service} from "../models/service";
import {DeleteServiceDialogComponent} from "./dialog/deleteServiceDialog.component";
import {Page} from "../models/page";
import {Services} from "../models/services";
import {Items} from "../models/items";
import {DatatableComponent} from "@swimlane/ngx-datatable";

@Component({
    templateUrl: './service.component.html',
    styleUrls: ['./service.component.scss']
})
export class ServiceComponent implements OnDestroy, OnInit {
    rows: any[];
    loadingIndicator: boolean;
    reorderable: boolean;
    deleteDialogRef: any;
    filterCategory: string;
    page = new Page();
    filters: any[];
    sort: any[] = [];
    filterValue: string;
    @ViewChild(DatatableComponent) table: DatatableComponent;

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private productService: ProductService,
        private alertService: AlertService,
        private serviceService: ServiceService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        public _matDialog: MatDialog,
    ) {
        componentTitleService.clearTitle();
        componentTitleService.addPart('Services');
        this.page.pageNumber = 0;
        this.page.size = 20;

        this.translationLoader.loadTranslations(polish, english);

        // Set the defaults
        this.loadingIndicator = true;
        this.reorderable = true;

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    ngOnInit() {
        this.setPage({ offset: 0 });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    showConfirmServiceDeleteDialog(event: Service) {
        this.deleteDialogRef = this._matDialog.open(DeleteServiceDialogComponent, {
            panelClass: 'contact-form-dialog',
            data      : {
                action : 'show',
                event: event,
            },
            width: '350px',
        });

        this.deleteDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.serviceService.delete(event.id).pipe(first())
                    .subscribe(res => {
                        window.location.reload();
                    });

                this.deleteDialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }

    setPage(pageInfo) {
        this.unsubscribe();
        this.loadingIndicator = true;
        this.page.pageNumber = pageInfo.offset;

        if (typeof pageInfo.limit === "undefined") {
            pageInfo.limit = this.page.size;
        }

        this.serviceService.getAllPaged(pageInfo.offset * pageInfo.limit, pageInfo.limit).subscribe((res: Services)=>{
            this.rows = res.items;
            this.loadingIndicator = false;
            this.page.totalElements = res.total;
        }, error => {
            this.alertService.error(error);
            this.loadingIndicator = false;
        })
    }

    filterByCategory(id: string|null) {
        if (id !== null) {
            this.serviceService.getAllByCategory(id).subscribe((res: Services) => {
                this.rows = res.items;
                this.loadingIndicator = false;
                this.page.totalElements = res.total;
            }, error => {
                this.alertService.error(error);
                this.loadingIndicator = false;
            });
        } else {
            this.setPage({ offset: 0 });
        }
    }

    sortResults(pageInfo) {
        this.rows = [];
        this.page.totalElements = 0;
        this.loadingIndicator = true;
        this.sort['sortDir'] = pageInfo.sorts[0].dir;
        this.sort['sortCol'] = pageInfo.sorts[0].prop;

        this.setPage({ offset: 0 });
    }

    updateFilter(event) {
        this.unsubscribe();
        this.filterValue = event.target.value.toLowerCase();

        if (this.filterValue.length < 3) {
            return;
        }

        this.loadingIndicator = true;
        this.filters = [];
        this.filters['name'] = this.filterValue;

        this.serviceService.getAllPaged(0, this.page.size, this.filters).pipe(takeUntil(this._unsubscribeAll))
            .subscribe( (res: Items) => {
                    this.rows = res.items;
                    this.loadingIndicator = false;
                    this.page.totalElements = res.items.length;
                },
                error => {
                    this.alertService.error(error);
                })

        this.table.offset = 0;
    }

    public unsubscribe(): void {
        this._unsubscribeAll.next();
    }
}
